// Status configuration shared between detail modals and table badges.
export const APPLICATION_STATUSES = [
    { value: "new", label: "Neu", color: "bg-aimploy-violet/10 text-aimploy-violet" },
    { value: "in_review", label: "In Prüfung", color: "bg-amber-50 text-amber-600" },
    { value: "interview", label: "Interview", color: "bg-blue-50 text-blue-600" },
    { value: "offer", label: "Angebot", color: "bg-emerald-50 text-emerald-600" },
    { value: "hired", label: "Eingestellt", color: "bg-emerald-100 text-emerald-700" },
    { value: "rejected", label: "Abgelehnt", color: "bg-red-50 text-red-500" },
];

export const CONTACT_STATUSES = [
    { value: "new", label: "Neu", color: "bg-aimploy-violet/10 text-aimploy-violet" },
    { value: "in_progress", label: "In Bearbeitung", color: "bg-amber-50 text-amber-600" },
    { value: "responded", label: "Beantwortet", color: "bg-blue-50 text-blue-600" },
    { value: "closed", label: "Geschlossen", color: "bg-emerald-50 text-emerald-700" },
    { value: "archived", label: "Archiviert", color: "bg-gray-100 text-gray-500" },
];

export const LEAD_STATUSES = [
    { value: "sent", label: "Versendet", color: "bg-emerald-50 text-emerald-700" },
    { value: "pending", label: "Ausstehend", color: "bg-amber-50 text-amber-600" },
    { value: "no_pdf", label: "Kein PDF hinterlegt", color: "bg-gray-100 text-gray-600" },
    { value: "failed", label: "Fehlgeschlagen", color: "bg-red-50 text-red-600" },
];

export const getStatusInfo = (statuses, value) =>
    statuses.find((s) => s.value === value) || statuses[0];

export const formatDateTime = (iso) => {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleString("de-DE", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return iso;
    }
};
